import { render, staticRenderFns } from "./PsPatientPhysicalActivityDetail.vue?vue&type=template&id=47a1b1d3&"
import script from "./PsPatientPhysicalActivityDetail.vue?vue&type=script&lang=js&"
export * from "./PsPatientPhysicalActivityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports